import { useEffect, useRef, useState } from "react";
import { AmenityIcon } from "@/lib/icons";
import { useLang } from "@/context/LanguageContext";
import roadrunnerSilhouette from "@/assets/roadrunner-silhouette.png";

export const Amenities = ({ property }) => {
  const { t } = useLang();
  const amenities = property?.amenities || [];
  const sectionRef = useRef(null);
  const [walking, setWalking] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setWalking(true);
          obs.disconnect();
        }
      },
      { threshold: 0.35 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="amenities" className="relative isolate overflow-hidden py-20 md:py-28 bg-background">
      <div
        style={{ right: "max(0px, calc((100vw - 80rem) / 4))" }}
        className="pointer-events-none absolute -z-10 md:translate-x-1/2 bottom-8 h-[90%]"
      >
        <div className={`h-full rr-travel ${walking ? "rr-walking" : ""}`}>
          <img src={roadrunnerSilhouette} alt="" aria-hidden="true" className="rr-bob h-full w-auto object-contain" />
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <p className="text-primary font-medium text-sm uppercase tracking-widest mb-2">{t("Everything you need")}</p>
          <h2 className="font-script text-6xl md:text-8xl leading-tight text-foreground">
            {t("Thoughtful amenities")}
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {amenities.map((a, i) => (
            <div
              key={a.label || i}
              data-testid={`amenity-${i}`}
              className="flex items-center gap-3 bg-accent/60 rounded-xl px-5 py-4 hover:bg-accent transition-colors"
            >
              <span className="flex-shrink-0 h-10 w-10 rounded-full bg-secondary/20 flex items-center justify-center">
                <AmenityIcon name={a.icon} className="h-5 w-5 text-secondary" />
              </span>
              <span className="text-foreground font-medium text-sm md:text-base">{t(a.label)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
